import React, { useState } from "react";
import { Container, Button, Box, CircularProgress } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import axios from "axios";
import { API_BASE_URL, ALTACARTAPDF, RUTACARTAPDF } from '../services/apiConfig';
import { registrarLogError , registrarAccion} from '../services/api.js';
function Carta() {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const usuarioid = userData?.usuarioid;

  const [selectedFile, setSelectedFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Verifica si el archivo es un PDF
    if (file && file.type !== "application/pdf") {
      setError('Por favor, selecciona un archivo PDF.');
    } else {
      setError('');
      setSelectedFile(file);
    }
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      setError('Por favor, selecciona un archivo PDF.');
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsUploading(true); // Comienza la subida del archivo
    try {
      const response = await axios.post(API_BASE_URL + ALTACARTAPDF, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

 if (response.data.status === "success") {
    console.log("Archivo subido exitosamente con estado:", response.status, response.data);
    setPdfUrl(response.data.url);
    setError('');
    await registrarAccion(usuarioid, ` se subio correctamente el pdf `);
    setSuccessMessage('¡El archivo se subió exitosamente!');
  } else {
    // Manejar códigos de estado que no son 2xx, pero que no lanzaron un error directamente
    console.error("La subida no fue exitosa. Estado:", response.status, "Datos:", response.message);
    setError(`La subida falló con el código: ${response.status}. Por favor, inténtalo de nuevo.`);
    registrarLogError(usuarioid, 'Carta', response.status + ' - ' + response.message); // Debes reemplazar 'App Nombre' por el nombre de tu aplicación
  }

} catch (error) {
  // El bloque catch ya maneja errores de red o errores 4xx/5xx que axios lanza
  console.error("Error al subir el archivo:", error);
  if (error.response) {
    // El servidor respondió con un código de estado de error (ej. 400, 500)
    console.error("Datos de error del servidor:", error.response.data);
    setError(`Error del servidor: ${error.response.data.message || 'Hubo un error inesperado.'}`);
  } else if (error.request) {
    // La solicitud fue hecha pero no se recibió respuesta (ej. problema de red)
    console.error("No se recibió respuesta del servidor:", error.request);
    setError('No se pudo conectar con el servidor. Verifica tu conexión a internet.');
  } else {
    // Algo más sucedió al configurar la solicitud
    setError('Hubo un error al preparar la solicitud de subida.');
  }
} finally {
  setIsUploading(false);
}
    /*try {
      const response = await axios.post(API_BASE_URL + ALTACARTAPDF, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Archivo subido:", response);
      setPdfUrl(response.data.url); // Guarda la URL del PDF subido
      setError('');
      setSuccessMessage('¡El archivo se subió exitosamente!');
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      setError('Hubo un error al subir el archivo.');
    } finally {
      setIsUploading(false); // Finaliza la subida del archivo
    }*/
  };


  return (
    <Container>
      <MenuInicial />

      <Box mt={4} display="flex" flexDirection="column" alignItems="center">
        <Box mb={2}>
          <input type="file" style={{ display: 'none' }} accept="application/pdf" onChange={handleFileChange} id="upload-file" />
          <label htmlFor="upload-file">
            <Button variant="contained" component="span">
              Examinar
            </Button>
          </label>
        </Box>
        {selectedFile && <p>Archivo seleccionado: {selectedFile.name}</p>}
        <Button variant="contained" color="primary" onClick={handleFileUpload}>
          Subir PDF
        </Button>
        {isUploading && <CircularProgress style={{ marginTop: '8px' }} />}
        {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
        {successMessage && <div style={{ color: 'green', marginTop: '8px' }}>{successMessage}</div>}
      </Box>

      {RUTACARTAPDF && (
        <Box mt={4} display="flex" justifyContent="center">
          <Button variant="outlined" color="primary" href={RUTACARTAPDF} target="_blank" rel="noopener noreferrer">
            Ver PDF
          </Button>
        </Box>
      )}
    </Container>
  );
}

export default Carta;
